var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSidemenuToggle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#055d9d",
    d: "M15.5 5H11l5 7l-5 7h4.5l5-7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#055d9d",
    d: "M8.5 5H4l5 7l-5 7h4.5l5-7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidemenuToggle);
export default __webpack_public_path__ + "static/media/ic_sidemenu_toggle.e4d1e27d503087bbd4a04fcf1ce72095.svg";
export { ForwardRef as ReactComponent };